import React from "react";
import {
  Menu,
  LogOut,
  Shield,
  UserCircle,
  Sparkles,
} from "lucide-react";
import logo from "../assets/logo.png";

const Topbar = ({ onToggleSidebar, onLogout, isDesktop }) => {
  const userName =
    localStorage.getItem("user_name") ||
    localStorage.getItem("name") ||
    "Admin";

  return (
    <header className="admin-topbar fixed inset-x-0 top-0 z-50 font-[kanit]">
      <div className="admin-topbar-glow admin-topbar-glow-left" />
      <div className="admin-topbar-glow admin-topbar-glow-right" />
      <div className="admin-topbar-shine" />

      <div className="relative z-10 flex h-16 items-center justify-between px-3 sm:px-4 md:px-6">
        <div className="flex min-w-0 items-center gap-3">
          {!isDesktop && (
            <button
              type="button"
              onClick={onToggleSidebar}
              className="admin-topbar-menu-button"
              aria-label="Toggle admin menu"
            >
              <Menu />
            </button>
          )}

          <div className="admin-topbar-logo-shell">
            <div className="admin-topbar-logo-ring">
              <img
                src={logo}
                alt="SL Gold"
                className="h-full w-full object-contain"
              />
            </div>
          </div>

          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <Shield className="admin-topbar-shield" />

              <h1 className="truncate font-serif text-[17px] font-medium tracking-[0.04em] text-[#F9E8C0] sm:text-lg">
                Admin Panel
              </h1>
            </div>

            <div className="mt-0.5 flex items-center gap-2">
              <span className="h-px w-5 bg-[#D4AF37]/70" />
              <p className="truncate text-[10px] uppercase tracking-[0.16em] text-white/50 sm:text-[11px]">
                Manage SL Gold Store
              </p>
            </div>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2 sm:gap-3">
          <div className="admin-topbar-admin-chip hidden sm:flex">
            <div className="admin-topbar-user-icon">
              <UserCircle />
            </div>

            <div className="min-w-0">
              <p className="truncate text-[10px] uppercase tracking-[0.16em] text-white/45">
                Administrator
              </p>

              <p className="max-w-[130px] truncate text-sm font-medium text-[#F9E8C0]">
                {userName}
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onLogout}
            className="admin-topbar-logout"
          >
            <LogOut />
            <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>

      <div className="admin-topbar-bottom-line">
        <span />
        <Sparkles />
        <span />
      </div>

      <style>{`
        .admin-topbar,
        .admin-topbar * {
          box-sizing: border-box;
        }

        .admin-topbar {
          height: 64px;
          overflow: hidden;
          border-bottom: 1px solid rgba(212, 175, 55, 0.32);
          color: white;
          background:
            radial-gradient(
              circle at 12% 0%,
              rgba(112, 12, 18, 0.58),
              transparent 30%
            ),
            radial-gradient(
              circle at 88% 100%,
              rgba(89, 6, 11, 0.42),
              transparent 34%
            ),
            linear-gradient(
              105deg,
              #170000 0%,
              #2B0000 42%,
              #200000 100%
            );
          box-shadow:
            0 12px 35px rgba(43, 0, 0, 0.22),
            inset 0 -1px 0 rgba(255, 255, 255, 0.035);
          isolation: isolate;
        }

        .admin-topbar::before {
          content: "";
          position: absolute;
          inset: 6px 10px;
          z-index: 1;
          border: 1px solid rgba(212, 175, 55, 0.07);
          border-radius: 12px;
          pointer-events: none;
        }

        .admin-topbar-glow {
          position: absolute;
          z-index: 0;
          border-radius: 50%;
          filter: blur(45px);
          pointer-events: none;
        }

        .admin-topbar-glow-left {
          top: -70px;
          left: 5%;
          width: 220px;
          height: 130px;
          background: rgba(120, 18, 24, 0.34);
        }

        .admin-topbar-glow-right {
          right: 8%;
          bottom: -65px;
          width: 180px;
          height: 120px;
          background: rgba(192, 127, 23, 0.1);
        }

        .admin-topbar-shine {
          position: absolute;
          top: -120%;
          left: -28%;
          z-index: 0;
          width: 35%;
          height: 340%;
          opacity: 0.06;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 239, 189, 0.9),
            transparent
          );
          transform: rotate(20deg);
          pointer-events: none;
        }

        .admin-topbar-menu-button {
          display: grid;
          width: 39px;
          height: 39px;
          flex: 0 0 auto;
          place-items: center;
          border: 1px solid rgba(212, 175, 55, 0.34);
          border-radius: 10px;
          color: #E9CD7A;
          background:
            linear-gradient(
              145deg,
              rgba(255, 255, 255, 0.055),
              rgba(255, 255, 255, 0.015)
            ),
            rgba(23, 0, 0, 0.55);
          box-shadow:
            0 8px 18px rgba(0, 0, 0, 0.18),
            inset 0 0 0 1px rgba(255, 255, 255, 0.025);
          cursor: pointer;
          transition:
            color 220ms ease,
            background 220ms ease,
            border-color 220ms ease,
            transform 220ms ease;
        }

        .admin-topbar-menu-button:hover {
          border-color: rgba(233, 205, 122, 0.72);
          color: #2B0000;
          background: #E9CD7A;
          transform: translateY(-2px);
        }

        .admin-topbar-menu-button svg {
          width: 19px;
          height: 19px;
          stroke-width: 1.8;
        }

        .admin-topbar-logo-shell {
          position: relative;
          width: 43px;
          height: 43px;
          flex: 0 0 auto;
        }

        .admin-topbar-logo-shell::before {
          content: "";
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          background: rgba(212, 175, 55, 0.08);
          filter: blur(6px);
        }

        .admin-topbar-logo-ring {
          position: relative;
          display: grid;
          width: 43px;
          height: 43px;
          place-items: center;
          overflow: hidden;
          border: 1px solid rgba(233, 205, 122, 0.6);
          border-radius: 50%;
          padding: 4px;
          background:
            radial-gradient(
              circle at 35% 20%,
              rgba(255, 245, 211, 0.18),
              transparent 50%
            ),
            rgba(255, 249, 239, 0.93);
          box-shadow:
            0 8px 20px rgba(0, 0, 0, 0.24),
            inset 0 0 0 3px rgba(212, 175, 55, 0.06);
        }

        .admin-topbar-shield {
          width: 15px;
          height: 15px;
          flex: 0 0 auto;
          color: #D4AF37;
          stroke-width: 1.8;
        }

        .admin-topbar-admin-chip {
          min-width: 175px;
          align-items: center;
          gap: 10px;
          min-height: 43px;
          padding: 6px 13px 6px 7px;
          border: 1px solid rgba(212, 175, 55, 0.2);
          border-radius: 999px;
          background:
            linear-gradient(
              115deg,
              rgba(255, 255, 255, 0.05),
              rgba(255, 255, 255, 0.015)
            ),
            rgba(23, 0, 0, 0.38);
          box-shadow:
            0 8px 20px rgba(0, 0, 0, 0.14),
            inset 0 0 0 1px rgba(255, 255, 255, 0.02);
        }

        .admin-topbar-user-icon {
          display: grid;
          width: 31px;
          height: 31px;
          flex: 0 0 auto;
          place-items: center;
          border: 1px solid rgba(233, 205, 122, 0.34);
          border-radius: 50%;
          color: #E9CD7A;
          background: rgba(43, 0, 0, 0.7);
        }

        .admin-topbar-user-icon svg {
          width: 17px;
          height: 17px;
          stroke-width: 1.6;
        }

        .admin-topbar-logout {
          display: inline-flex;
          min-height: 40px;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 8px 15px;
          border: 1px solid rgba(233, 205, 122, 0.36);
          border-radius: 9px;
          color: #F9E8C0;
          background:
            linear-gradient(
              135deg,
              rgba(103, 8, 13, 0.7),
              rgba(43, 0, 0, 0.88)
            );
          box-shadow:
            0 9px 22px rgba(0, 0, 0, 0.19),
            inset 0 0 0 1px rgba(255, 255, 255, 0.025);
          font-family: inherit;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition:
            color 220ms ease,
            background 220ms ease,
            border-color 220ms ease,
            transform 220ms ease,
            box-shadow 220ms ease;
        }

        .admin-topbar-logout:hover {
          border-color: #E9CD7A;
          color: #2B0000;
          background: #E9CD7A;
          transform: translateY(-2px);
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.24);
        }

        .admin-topbar-logout svg {
          width: 17px;
          height: 17px;
          stroke-width: 1.8;
        }

        .admin-topbar-bottom-line {
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 12;
          display: flex;
          align-items: center;
          gap: 9px;
          color: rgba(212, 175, 55, 0.48);
          pointer-events: none;
        }

        .admin-topbar-bottom-line span {
          flex: 1;
          height: 1px;
          background: linear-gradient(
            90deg,
            transparent,
            currentColor,
            transparent
          );
        }

        .admin-topbar-bottom-line svg {
          width: 11px;
          height: 11px;
          color: #D4AF37;
        }

        @media (max-width: 639px) {
          .admin-topbar::before {
            inset-inline: 5px;
          }

          .admin-topbar-logo-shell,
          .admin-topbar-logo-ring {
            width: 39px;
            height: 39px;
          }

          .admin-topbar-logout {
            width: 40px;
            padding-inline: 0;
          }
        }

        @media (max-width: 380px) {
          .admin-topbar-menu-button {
            width: 36px;
            height: 36px;
          }

          .admin-topbar-logo-shell,
          .admin-topbar-logo-ring {
            width: 36px;
            height: 36px;
          }

          .admin-topbar h1 {
            font-size: 15px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .admin-topbar-menu-button,
          .admin-topbar-logout {
            transition: none !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Topbar;